import {Layout, LayoutChild, MainLayout} from "../../../../palette/Palette";
import login from '../../../../assets/img/Login.png'
import VerticalSpace from "../../../../palette/VerticalSpace";
import {useFontStyles} from "../../../../assets/fontStyles/FontStyles";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import {useHistory} from "react-router-dom";
import {inject, observer} from "mobx-react";

const imageStyle = {
    backgroundImage: `url(${login})`,
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
}

function Info(props) {

    const {heightContainer, login, create, recover, setLogin, setCreate, setRecover} = props

    const classFonts = useFontStyles()

    let history = useHistory();

    const creteAccount = () => {
        setCreate(true)
        setLogin(false)
        setRecover(false)
        history.push('/main/create-account');
    }

    const onLogin = () => {
        setCreate(false)
        setLogin(true)
        setRecover(false)
        history.push('/main/login');
    }

    const onRecover = () => {
        setCreate(false)
        setLogin(false)
        setRecover(true)
        history.push('/main/recover-password');
    }

    return (
        <div style={imageStyle}>
            <MainLayout height={heightContainer} center positionC color={'rgba(84, 110, 122, 0.84)'} radius={5}>
                <Layout center positionC>
                    <div style={{height: 100}}/>
                </Layout> <Layout center positionC>
                <Layout center positionC>
                    {/*<span className={classFonts.companyText}>IKU</span>*/}
                    <VerticalSpace space={120}/>
                </Layout>

            </Layout>
                <VerticalSpace space={10}/>
                <Layout center positionC>
                    <span className={classFonts.infoSpan}>La mejor manera de administrar</span>
                    <span className={classFonts.infoSpan}>tu empresa de transporte</span>
                </Layout>
                <VerticalSpace space={60}/>
                <VerticalSpace space={20}/>
                <Layout center>
                    <LayoutChild width={200} center row>
                        <FiberManualRecordIcon className={classFonts.iconSession}/>
                        {(create && !login) &&
                        <span className={classFonts.sessionText} onClick={onLogin}>Iniciar sesión</span>}
                        {(!create && recover) &&
                        <span className={classFonts.sessionText} onClick={onLogin}>Iniciar sesión</span>}
                        {(!create && !recover) &&
                        <span className={classFonts.sessionText} onClick={creteAccount}>Crear cuenta</span>}
                    </LayoutChild>
                </Layout>
                <VerticalSpace space={5}/>
                <Layout center>
                    <LayoutChild width={200} center row>
                        <FiberManualRecordIcon className={classFonts.iconSession}/>
                        <span className={classFonts.sessionText} onClick={onRecover}>Olvidó su contraseña</span>
                    </LayoutChild>
                </Layout>
            </MainLayout>
        </div>
    )
}

export default inject('SessionStore')(observer(Info));